import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShowSidebarService {
  public showSidebar = false;
}
